import React, {useEffect, useState} from 'react'
import axios from 'axios'
import { Table, TableBody, TableCell, TableHead, TableHeadCell, TableRow } from "flowbite-react";
import { PencilSquareIcon, ArrowUpTrayIcon, ListBulletIcon, PlayCircleIcon, PaperClipIcon } from '@heroicons/react/24/outline'
import Modals from '../../components/Modal'
import Content from '../contents/content'
import File from '../files/File'
import { useNavigate } from "react-router-dom";
import PermissionWrapper from '../../hooks/PermissionWrapper';
import LoadingSpinner from '../../components/LoadingSpinner';


const dash = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = () => setIsModalOpen(false);
    const [modalTitle, setModalTitle] = useState("");
    const [solutionId, setSolutionId] = useState(null);
    const navigate = useNavigate();
    const [origen,setOrigen] = useState("");
    const [solutionName,setSolutionName] = useState("");
    const [solutions, setSolutions] = useState([]);
    const [error, setError] = useState(null);
    const [solutionDisplay, setSolutionDisplay] = useState(false);
        const [isLoading, setIsLoading] = useState(false);
    const [idUser, setUserId] = useState(() => {
        const user = JSON.parse(localStorage.getItem("User") || "[]");
        return user?.id || null; // devuelve el id o null si no existe
        })

    const openModal = (title,idSolution,origen, solutionName) => {
        setOrigen(origen);
        setModalTitle(title);
        setIsModalOpen(true);
        setSolutionId(idSolution);
        setSolutionName(solutionName);
    };

    const handleFormSubmit = (data) => {
        console.log("Datos del formulario:", data);
        closeModal(); // Cierra la modal después de enviar
      };

    const handleGoToSolution = (solutionId) => {
        navigate(`./solucion/${solutionId}/view`);
    }

    const handleGoToYoutube = (playList) => {
        window.open(`https://www.youtube.com/playlist?list=${playList}`, '_blank');
    }

    useEffect(()=>{
        const getSolutions = async () => {
            setIsLoading(true);
            try{
                const response = await axios.get(
                    `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/solutions`,
                    {
                        withCredentials: true,
                    }
                );
                if (response.statusText !== "OK") {
                    throw new Error(response.message || 'Error en la obtención de datos');
                }
                
                setSolutions(response.data);
                setIsLoading(false);
            } catch (err) {
                setError(err.message);
            }
        }
        getSolutions();
    }, []);
    
    return (
        <>
            {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
            <div className="p-2 mt-4">
                <h1 className="text-xl mb-2">Dashboard</h1>
                {error && <div className="text-red-500">{error}</div>}
            </div>
            <div className="overflow-x-auto">
                <Table>
                    <TableHead>
                        <TableHeadCell className="px-4 text-left">Solución</TableHeadCell>
                        <TableHeadCell className="px-0 text-left">Descripción</TableHeadCell>
                        <TableHeadCell className="px-0 text-left">Estado</TableHeadCell>
                        <TableHeadCell>
                            <span className="srOnly">Acción</span>
                        </TableHeadCell>
                    </TableHead>
                    <TableBody className="divide-y">
                        {solutions.map((sol) => (
                            <TableRow key={sol.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                <TableCell className="whitespace-nowrap font-medium text-gray-900 dark:text-white w-32 p-1 px-4">
                                    {sol.name}
                                </TableCell>
                                <TableCell className=" p-1">{sol.description}</TableCell>
                                <TableCell className=" p-1">{(sol.status)?'Activo':'Inactivo'}</TableCell>
                                <TableCell className="inline-flex p-1">
                                    {sol.userIds?.split(",").includes(String(idUser)) && (
                                        <PermissionWrapper requiredPermissions={['file_upload']}>
                                        <a href="#" className="text-gray-800 m-2" onClick={()=>openModal("Carga de instaladores",sol.id,'file', sol.name)} title="Cargar instalador">
                                            <ArrowUpTrayIcon className="w-5 text-blue-500 mr-3" />
                                        </a>
                                        </PermissionWrapper>
                                    )}
                                    {sol.userIds?.split(",").includes(String(idUser)) && (
                                    <PermissionWrapper requiredPermissions={['file_upload']}>
                                    <a href="#" className="text-gray-800 m-2" onClick={ ()=>openModal("Carga de adicionales",sol.id, 'adicionales', sol.name) } title="Cargar adicionales">
                                        <ListBulletIcon className="w-5 text-blue-500 mr-3"/>
                                    </a>
                                    </PermissionWrapper>
                                    )}
                                    {(sol.fileCount > 0) && (
                                        <PermissionWrapper requiredPermissions={['default']}>
                                            <a href="#" className="text-gray-800 m-2" onClick={ ()=>handleGoToSolution(sol.id) }  title="Ver instaladores">
                                                <PaperClipIcon className="w-5 text-blue-500 mr-3"/>
                                            </a>
                                        </PermissionWrapper>
                                    )}
                                    {(sol.youtube_playlist_id) && (

                                        <a href="#" className="text-gray-800 m-2" onClick={ ()=>handleGoToYoutube(sol.youtube_playlist_id) } title="Ver lista de reproducción">
                                            <PlayCircleIcon className="w-5 text-blue-500 mr-3"/>
                                        </a>

                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>

            <Modals isOpen={isModalOpen} onClose={closeModal} title={modalTitle} modalSize={"4xl"}>
                {   
                    (origen=='file') && (
                        <File solutionId={solutionId} onClose={closeModal} solutionName={solutionName}/>
                    )
                }
                {
                    (origen=='adicionales') && (
                        <Content solutionId={solutionId} onClose={closeModal} solutionName={solutionName}/>
                    )
                }
            </Modals>
        </>
    )
}

export default dash
